// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import {
  NewsInfoResponseDTO,
  NewsSearchRequestDTO
} from "../../api/backend-openapi";
import { TablePaginationConfig } from "antd/lib/table/interface";
import { Moment } from "moment";
import { TemplateInputImagePropertiesDto } from "../../utils/htmlTemplate/dto/template.dto";

export interface NewsSearchFormProps {
  pagination: TablePaginationConfig;
  dataHasLoaded: boolean;
  setDataHasLoaded: (dataHasLoaded: boolean) => void;
  onSearchDtoUpdate: (searchDto: NewsSearchRequestDTO) => void;
}

export interface NewsFormProps {
  editMode?: boolean;
}

export interface NewsStatusTagProps {
  status: string;
}

export interface NewsRefusedFormProps {
  newsId: string;
}

export interface NewsEditFormProps extends NewsFormProps {
  newsId: string;
  setEditMode: (editMode: boolean) => void;
  canEdit: boolean;
  canValidate: boolean;
  canDelete: boolean;
}

export interface NewsFormSectionProps extends NewsFormProps {
  news?: NewsInfoResponseDTO | null;
  previewFields: PreviewFields;
  setPreviewFields: (previewFields: PreviewFields) => void;
  showRequired?: boolean;
}

export interface NewsBlocksProps extends NewsFormProps {
  blocks: Block[];
  setBlocks: (blocks: Block[]) => void;
}

export interface NewsAddBlockButtonProps {
  buttonLabel: string;
  index?: number;
  handleAddBlock: (block: Block, index?: number) => void;
}

export interface NewsImageProps extends NewsFormProps {
  formFieldLabel: string;
  formFieldName: string;
  base64Url?: string;
  newsId?: string;
  inputIndex?: number;
  inputProperties?: TemplateInputImagePropertiesDto;
  onChangeCallBack?: (base64url: string, type: string, index?: number) => void;
  setImage?: (image: Image) => void;
  rules?: ImageRules;
}

export interface OptionType {
  value: string;
  label: string;
}

export interface Field {
  name: string[];
  value: string | Moment | (Moment | OptionType | string | undefined)[];
}

export interface Block {
  idTempLocal?: number;
  templateId: string;
  inputs: Input[];
}

export interface Format {
  inputs: Input[];
}

export interface Input {
  inputType: string;
  content: string;
  properties?: string;
}

export interface NewsBlockProps extends NewsFormProps {
  readOnly?: boolean;
  indexBlock: number;
  block: Block;
  handleAddBlock: (block: Block, index?: number) => void;
  handleUpdateBlock: (block: Block, index: number) => void;
  handleDeleteBlock: (index: number) => void;
  handleAscendBlock?: (index: number) => void;
  handleDescendBlock?: (index: number) => void;
}

export interface Image {
  base64Data: string;
  type: string;
  name: string;
}

export interface PreviewFields {
  title?: string;
  summary?: string;
  newsThemeId?: string;
}

export interface ImageRules {
  width?: number;
  height?: number;
  size?: number;
}

export enum NewsWorkflowStatus {
  PUBLISHED = "PUBLISHED",
  VALIDATION = "VALIDATION",
  VALIDATED = "VALIDATED",
  REFUSED = "REFUSED",
  SAVED = "SAVED"
}
